module.exports =[
  {
    conditions: {
      status: 0, // draft
    },
    style: 'warning',
    icon: 'fa fa-inbox',
    label: 'Orders.statusReceived',
    name: 'received',
    title: 'Orders.statusReceived',
    description: 'Orders.statusReceivedDescr',
    optional: false,
    terminate: false,
  },
  {
    // order excepted
    conditions: {
      status: 1, // booked
      orderstatus: [
        'order_accepted',
        'master_approval_required',
        'customer_approval_required',
        'customer_approved'
      ],
    },
    style: 'warning',
    icon: 'fa fa-thumbs-up',
    label: 'Orders.statusInProgress',
    name: 'inprogress',
    title: 'Orders.statusInProgress',
    description: 'Orders.statusInProgressDescr',
    optional: false,
    terminate: false,
  },
  {
    conditions: {
      status: 3, // Cancelled
    },
    style: 'warning',
    icon: 'fa fa-times',
    label: 'Orders.statusCancelled',
    name: 'cancelled',
    title: 'Orders.statusCancelled',
    description: 'Orders.statusCancelledDescr',
    optional: true,
    terminate: true,
  },
  {
    // production started
    conditions: {
      status: 1, // booked
      orderstatus: ['in_production', 'rework_required']
    },
    style: 'info',
    icon: 'fa fa-cogs',
    label: 'Orders.statusInProduction',
    name: 'inproduction',
    title: 'Orders.statusInProduction',
    description: 'Orders.statusInProductionDescr',
    optional: false,
    terminate: false,
  },
  {
    conditions: {
      status: [1, 4, 12], // Complete
      orderstatus: 'shipped',
    },
    style: 'warning',
    icon: 'fa fa-truck',
    label: 'Orders.statusDelivered',
    name: 'delivered',
    title: 'Orders.statusDelivered',
    description: 'Orders.statusDeliveredDescr',
    optional: false,
    terminate: false,
  }
];
